var _mask, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "donut_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.703 118.685a80 80 0 10154.549-41.41L97.977 97.98l-77.274 20.705z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.703 118.685a80 80 0 10154.549-41.41L97.977 97.98l-77.274 20.705z",
    fill: "#F68282",
    stroke: "#000",
    strokeWidth: 10,
    mask: "url(#donut_svg__a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.665,
    cy: 98.524,
    r: 43.9,
    transform: "rotate(-105 97.665 98.524)",
    fill: "#F2DA3A",
    stroke: "#000",
    strokeWidth: 5
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTk2IiBoZWlnaHQ9IjE5NiIgdmlld0JveD0iMCAwIDE5NiAxOTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8bWFzayBpZD0icGF0aC0xLWluc2lkZS0xXzEyOTlfMTAxMSIgZmlsbD0id2hpdGUiPgogICAgICAgIDxwYXRoIGQ9Ik0yMC43MDM0IDExOC42ODVDMjYuMTk0OCAxMzkuMTggMzkuNjAyNyAxNTYuNjUzIDU3Ljk3NzUgMTY3LjI2MkM3Ni4zNTIyIDE3Ny44NyA5OC4xODg2IDE4MC43NDUgMTE4LjY4MyAxNzUuMjU0QzEzOS4xNzcgMTY5Ljc2MiAxNTYuNjUxIDE1Ni4zNTQgMTY3LjI1OSAxMzcuOThDMTc3Ljg2OCAxMTkuNjA1IDE4MC43NDMgOTcuNzY4NSAxNzUuMjUyIDc3LjI3NDJMOTcuOTc3NCA5Ny45Nzk3TDIwLjcwMzQgMTE4LjY4NVoiLz4KICAgIDwvbWFzaz4KICAgIDxwYXRoIGQ9Ik0yMC43MDM0IDExOC42ODVDMjYuMTk0OCAxMzkuMTggMzkuNjAyNyAxNTYuNjUzIDU3Ljk3NzUgMTY3LjI2MkM3Ni4zNTIyIDE3Ny44NyA5OC4xODg2IDE4MC43NDUgMTE4LjY4MyAxNzUuMjU0QzEzOS4xNzcgMTY5Ljc2MiAxNTYuNjUxIDE1Ni4zNTQgMTY3LjI1OSAxMzcuOThDMTc3Ljg2OCAxMTkuNjA1IDE4MC43NDMgOTcuNzY4NSAxNzUuMjUyIDc3LjI3NDJMOTcuOTc3NCA5Ny45Nzk3TDIwLjcwMzQgMTE4LjY4NVoiIGZpbGw9IiNGNjgyODIiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMTAiIG1hc2s9InVybCgjcGF0aC0xLWluc2lkZS0xXzEyOTlfMTAxMSkiLz4KICAgIDxjaXJjbGUgY3g9Ijk3LjY2NTIiIGN5PSI5OC41MjM2IiByPSI0My45IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTA1IDk3LjY2NTIgOTguNTIzNikiIGZpbGw9IiNGMkRBM0EiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iNSIvPgo8L3N2Zz4K";
export { SvgDonut as ReactComponent };